import React from "react";
import { Card, Col, Row, Typography, Descriptions, Table, Tag, Button } from "antd";

const { Title } = Typography;

const StudentView = () => {
  // Static data (mock)
  const studentData = {
    name: "Arjun Verma",
    className: "CLS-101",
    belt: "Yellow",
    attendance: 82,
    badge: true,
    exams: [
      { examId: 1, examName: "Midterm", score: 85, date: "2025-05-12" },
      { examId: 2, examName: "Final", score: 91, date: "2025-06-22" },
    ],
    rewards: [
      { rewardId: 1, name: "Best Discipline", date: "2025-06-20" },
      { rewardId: 2, name: "Consistent Attendance", date: "2025-07-01" },
    ],
  };

  return (
   <>
    <Button
        type="default"
        className="mb-2"
        style={{ color: "black" }}
        onClick={() => window.history.back()}
      >
        Back
      </Button>
   <Card title="Student Profile">
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Name">{studentData.name}</Descriptions.Item>
          <Descriptions.Item label="Class">{studentData.className}</Descriptions.Item>
          <Descriptions.Item label="Belt">{studentData.belt}</Descriptions.Item>
          <Descriptions.Item label="Attendance">{studentData.attendance}%</Descriptions.Item>
          <Descriptions.Item label="Badge Status">
            {studentData.badge ? (
              <Tag color="green">Awarded</Tag>
            ) : (
              <Tag color="red">Pending</Tag>
            )}
          </Descriptions.Item>
        </Descriptions>

        <Row gutter={[16, 16]} className="mt-4">
          <Col xs={24} md={12}>
            <Title level={5}>Exam Scores</Title>
            <Table
              dataSource={studentData.exams}
              pagination={false}
              columns={[
                { title: "Exam", dataIndex: "examName", key: "examName" },
                { title: "Score", dataIndex: "score", key: "score" },
                { title: "Date", dataIndex: "date", key: "date" },
              ]}
              rowKey="examId"
            />
          </Col>

          <Col xs={24} md={12}>
            <Title level={5}>Rewards</Title>
            <Table
              dataSource={studentData.rewards}
              pagination={false}
              columns={[
                { title: "Reward", dataIndex: "name", key: "name" },
                { title: "Date", dataIndex: "date", key: "date" },
              ]}
              rowKey="rewardId"
            />
          </Col>
        </Row>
   </Card>
   </>
  );
};

export default StudentView;
